export default __webpack_public_path__ + "static/media/no-preview.62acc9c6.svg";